export const APP_CONFIG = {
  // REQUIRED
  appName: "StarterKitPro Blocks",
  // REQUIRED: a short description of your app for SEO tags (can be overwritten)
  appTagline: "Free, Modern Landing Page Blocks for Shadcn/ui.",
  appDescription:
    "Discover our collection of ready-to-use, professionally designed UI blocks. Simply copy, paste, and customize for any React project. Fully responsive, accessible, and completely free.",
  // REQUIRED (no https://, not trialing slash at the end, just the naked domain)
  domainName: "blocks.starterkitpro.com",
  // Full URL based on environment
  domainUrl:
    process.env.NODE_ENV === "production"
      ? "https://blocks.starterkitpro.com"
      : "http://localhost:3000",

  colors: {
    primary: "#df8709",
  },
  supportEmail: "hasan@starterkitpro.com",
  links: {
    twitter: "https://x.com/hasanDevpreneur",
    linkedIn: "https://www.linkedin.com/in/hasan-devpreneur",
  },
};

export type AppConfig = typeof APP_CONFIG;
